import { link, type RouterLinkProps } from "@/components/Action.tsx";
import { Navigate } from "@tanstack/react-router";

export function NavigateAfterDelete({ action = link({ to: "/" }) }: { action?: RouterLinkProps }) {
    return <Navigate replace {...action} />;
}
